import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
import templateOnly from "@ember/component/template-only";
const ActionButton = setComponentTemplate(precompileTemplate("\n  {{#unless @isReadOnly}}\n    {{!-- Force the type to \"button\" otherwise it is a \"submit\" type in a form --}}\n    <button type=\"button\" ...attributes>{{yield}}</button>\n  {{/unless}}\n", {
  strictMode: true
}), templateOnly(undefined, "action-button:ActionButton"));
export default ActionButton;